export default "/assets/images/column-image2.37340bd499f10911.webp";